import { render } from "./modal-gestion.vue?vue&type=template&id=4a17fc84"
import script from "./modal-gestion.vue?vue&type=script&lang=js"
export * from "./modal-gestion.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\domin\\Desktop\\workspace\\hub-web-apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__